'use client';
import React from 'react';
import Slider from 'react-slick';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';

import { LeftArrow, RightArrow } from '@repo/ui/src/components/Carousels/CarouselArrows';
import { productImagesMainSettings } from './variables';
import { ProductImagesContainer } from './styles';

interface Props {
  photos: Array<MediaType>;
  quantity: number;
}

const ProductImages = ({ photos, quantity }: Props) => {
  const [nav1, setNav1] = React.useState(null);
  const [nav2, setNav2] = React.useState(null);
  const slider1 = React.createRef<any>();
  const slider2 = React.createRef<any>();

  const navSettings: any = React.useMemo(
    () => ({
      infinite: true,
      arrows: true,
      slidesToShow: quantity,
      slidesToScroll: 1,
      swipeToSlide: true,
      focusOnSelect: true,
      nextArrow: <RightArrow arrowSize="22px" />,
      prevArrow: <LeftArrow arrowSize="22px" />,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 770,
          settings: {
            slidesToShow: quantity,
          },
        },
      ],
    }),
    [quantity],
  );

  React.useEffect(() => {
    if (slider1?.current) {
      setNav1(slider1.current);
    }
    if (slider2?.current) {
      setNav2(slider2.current);
    }
  }, [slider1, slider2]);

  return (
    <ProductImagesContainer>
      <Slider asNavFor={nav2} ref={slider1} {...productImagesMainSettings}>
        {photos &&
          photos.map((image, i) => {
            const imageUrl = buildImageSrc(image, 500, 1, 1);
            return (
              <div key={`${image.endpoint}-${i}`} className="tw-relative">
                <div>
                  <LazyLoadImage
                    imgComponent={
                      <img
                        key={`main${image.name}-${i}`}
                        className="img-fluid-pdp main-product-image"
                        src={imageUrl}
                        alt={image.name}
                      />
                    }
                  />
                </div>
              </div>
            );
          })}
      </Slider>
      {photos?.length > 1 && (
        <div className="tw-mb-6">
          <Slider asNavFor={nav1} ref={slider2} {...navSettings}>
            {photos &&
              photos.map((image, i) => {
                const imageUrl = buildImageSrc(image, 50, 1, 1);
                return (
                  <div className="navSliderItems" key={`Slider--image-${i}`}>
                    <LazyLoadImage
                      imgComponent={
                        <img
                          key={`nav${image.name}`}
                          className="img-fluid-slider-thumbnail"
                          src={imageUrl}
                          alt={image.name}
                        />
                      }
                    />
                  </div>
                );
              })}
          </Slider>
        </div>
      )}
    </ProductImagesContainer>
  );
};

export default ProductImages;
